import {
	section,
	container,
	cardTitle,
	grayColor,
	roseColor,
	coloredShadow,
} from "assets/jss/material-kit-pro-react.js";

const styles = {
	cardTitle,
	container,
	section: {
		...section,
		padding: "70px 0px",
	},
	coloredShadow,
	cardDescription: {
		color: grayColor[0],
	},
	cardCategory: {
		marginTop: "10px",
	},
	textRose: {
		color: roseColor[0] + " !important",
	},
	headerImage: {
		height: "100px",

		background: "linear-gradient(60deg, #fffcfc, #dadada)",
		backgroundSize: "cover",
		backgroundPosition: "center center",
		shadow: "0 2px 4px 2px rgba(0, 0, 0, 0.2) !important",
		boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2) !important",
		padding: "10px",
	},
};

export default styles;
